export default __webpack_public_path__ + "static/media/screen_33.08dfa74a.png";